export const soundTypes = ['one-shot', 'stem', 'loop'] as const
export type SoundType = typeof soundTypes[number]

export type SoundValidationParams = {
  minBPM: number
  maxBPM: number
  minDuration: number
  maxDuration: number
}

/**
 * Returns the validation params for the given type.
 */
export const getSoundValidationParams = (type: SoundType): SoundValidationParams => {
  if (type === 'one-shot') {
    return {
      minBPM: 0,
      maxBPM: 0,
      minDuration: 0,
      maxDuration: 10
    }
  } else if (type === 'stem') {
    return {
      minBPM: 1,
      maxBPM: 300,
      minDuration: 3,
      maxDuration: 300
    }
  } else if (type === 'loop') {
    return {
      minBPM: 1,
      maxBPM: 300,
      minDuration: 3,
      maxDuration: 300
    }
  }
}
